import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {
  TableRow,
  TableCell,
  Checkbox,
  IconButton,
  Tooltip
} from '@mui/material';

type JiraIssueRowProp = {
  jiraKey: string;
  summary: string;
  idJira: string;
  handleIssueAdd: Function;
  handleIssueSelect: Function;
  isIssueSelected: Function;
};

const JiraIssueRow = ({
  jiraKey,
  summary,
  idJira,
  handleIssueAdd,
  handleIssueSelect,
  isIssueSelected
}: JiraIssueRowProp) => {
  return (
    <TableRow key={idJira} hover>
      <TableCell padding="checkbox">
        <Checkbox
          checked={isIssueSelected(idJira)}
          onChange={(e) => handleIssueSelect(idJira, e.target.checked)}
          inputProps={{ 'aria-label': 'Select Jira issue' }}
        />
      </TableCell>

      <TableCell sx={{ wordBreak: 'keep-all', width: 100 }}>
        {jiraKey}
      </TableCell>

      <TableCell>{summary}</TableCell>

      <TableCell>{idJira}</TableCell>

      <TableCell align="center">
        <Tooltip title="Add Task">
          <IconButton
            onClick={() =>
              handleIssueAdd([{ key: jiraKey, idJira, summary }])
            }
            color="primary"
            size="small"
          >
            <AddCircleOutlineIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default JiraIssueRow;